import {
  Dialog,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { Delete } from "@mui/icons-material";
import ConfirmationModal from "../../../../../App/Components/Modals/ConfirmationModal";
import { callAPI } from "../../../../../App/Helpers/callApi";
import {
  deleteFeaturedEvent,
  getFeaturedEvents,
} from "../../../FeaturedEventsService";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { basicSort } from "../../../../../App/Helpers/BasicSort";
import { basicConvertDate } from "../../../../../App/Helpers/DateConverters";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function FeaturedEventsTableCell({
  columns,
  element,
  index,
  setTableData,
}) {
  const classes = useStyles();
  const [deleteModal, setDeleteModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const callDeleteJob = () => {
    callAPI(
      deleteFeaturedEvent(element.id),
      "Event Deleted",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getFeaturedEvents(element.clientId).then((response) => {
        response.sort((a, b) => {
          const order = basicSort(a.order, b.order);
          if (order !== 0) return order;
          return a[1] - b[1];
        });
        response.forEach(
          (row) => (row.event.startDate = basicConvertDate(row.event.startDate))
        );
        response.forEach(
          (row) => (row.event.endDate = basicConvertDate(row.event.endDate))
        );
        setTableData(response);
      });
    });
  };

  function openModal(e) {
    e.preventDefault();
    setDeleteModal(true);
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <TableRow
        hover
        key={index}
        className={index % 2 ? classes.rowCell : classes.rowCellOdd}
        style={{ background: index % 2 ? "rgba(0,0,0,.08)" : "white" }}
      >
        {columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Delete" ? (
              <Tooltip title="Delete Featured Event">
                <IconButton onClick={(e) => openModal(e)} size="large">
                  <Delete />
                </IconButton>
              </Tooltip>
            ) : (
              element[column.propName.split(".")[0]][
                column.propName.split(".")[1]
              ]
            )}
          </TableCell>
        ))}
      </TableRow>
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ConfirmationModal
          question="Delete this featured event?"
          func={() => callDeleteJob()}
          closeModal={() => setDeleteModal(false)}
        />
      </Dialog>
    </>
  );
}
